import {
  redoCartIdFormat,
  redoCartItemIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

const RedoCartItemSchema_ = z.object({
  id: redoCartItemIdFormat.schema,
  cartId: redoCartIdFormat.schema,
  productId: z.string(),
  title: z.string(),
  price: z.number(),
  currency: z.string(),
  imageUrl: z.string().nullable(),
  options: z.array(z.object({ name: z.string(), value: z.string() })),
  quantity: z.number(),
});
export const RedoCartItemSchema: z.ZodType<RedoCartItem> = RedoCartItemSchema_;
export interface RedoCartItem extends z.infer<typeof RedoCartItemSchema_> {}

const RedoCartSchema_ = z.object({
  id: redoCartIdFormat.schema,
  status: z.string(),
  items: z.array(RedoCartItemSchema),
});
export const RedoCartSchema: z.ZodType<RedoCart> = RedoCartSchema_;
export interface RedoCart extends z.infer<typeof RedoCartSchema_> {}

const RedoCartOutput = z.object({ cart: RedoCartSchema.nullable() });

export const getRedoCart = {
  name: "getRedoCart" as const,
  input: z.object({}),
  output: RedoCartOutput,
};

export const upsertRedoCartItems = {
  name: "upsertRedoCartItems" as const,
  input: z.object({
    productId: z.string(),
    quantityDelta: z.number(),
    title: z.string(),
    price: z.number(),
    currency: z.string(),
    imageUrl: z.string().nullable(),
    options: z.array(z.object({ name: z.string(), value: z.string() })),
  }),
  output: RedoCartOutput,
};
